import { Layers } from '../index';

export interface CommerceProduct {
  productId: string;
  price: number;
  currency: string;
  name?: string;
  category?: string;
  quantity?: number;
}

export interface CommerceTransaction {
  transactionId: string;
  store: 'app_store' | 'play_store' | 'stripe' | 'custom';
  revenue: number;
  currency: string;
  products: CommerceProduct[];
}

export const Commerce = {
  /**
   * Track a successful purchase manually.
   * Use this if you are managing IAP code yourself (e.g. react-native-iap).
   */
  trackPurchase: async (transaction: CommerceTransaction) => {
    try {
      // 1. Track the main purchase event
      await Layers.track('purchase_success', {
        product_id: transaction.products.map((p) => p.productId).join(','), // Primary ID or list
        transaction_id: transaction.transactionId,
        store: transaction.store,
        revenue: transaction.revenue,
        currency: transaction.currency,
        quantity: transaction.products.reduce((acc, p) => acc + (p.quantity ?? 1), 0),
        items: transaction.products // Pass full items array for rich backend analysis
      });

      // 2. (Optional) Helper: If it's a single item subscription start, we might want to infer that,
      // but it's safer to stick to raw purchase events for the generic helper.
    } catch (e) {
      console.warn('[Layers] Failed to track purchase:', e);
    }
  }
};
